import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { Dispatch, FC, SetStateAction, useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import { guid } from 'core/classes/helpers/GuidHelper'
import { HPContactRequestEditor } from 'partner360/features/hpContacts'
import { getJbpHpContactsCrud } from 'partner360/features/hpContacts/lib'

import { DEFAULT_STATE } from '../../configs'

interface UamHpContactRequestEditor {
  showRequestAccessDialog: boolean
  setShowRequestAccessDialog: Dispatch<SetStateAction<boolean>>
  partnerId: string
  user: IUser
}

export const UamHpContactRequestEditor: FC<UamHpContactRequestEditor> = ({
  showRequestAccessDialog,
  setShowRequestAccessDialog,
  partnerId,
  user,
}) => {
  const applyRequestAccessHandler = useCallback(
    async (newRequest: IFormJBPHPContactChangeRequest) => {
      const jbpHpContactChangeRequestCrud = getJbpHpContactsCrud('JBPSalesTeam-WithTickets-uam')
      newRequest = {
        ...newRequest,
        EntryId: -1,
        Status: newRequest.TicketStatus,
        Action: newRequest.RequestAction,
        SignId: newRequest.SignId || `new-${guid()}`,
      }
      await jbpHpContactChangeRequestCrud.create(
        { formId: '1217', code: 'jbp-hp-contact-change-request-1217' },
        [newRequest]
      )
    },
    []
  )

  return (
    <>
      <ModalDialog
        show={showRequestAccessDialog}
        size={'sm'}
        content={HPContactRequestEditor}
        contentProps={{
          isVisible: showRequestAccessDialog,
          currentHpContactRequest: {
            ...DEFAULT_STATE,
            FirstName: user.firstName,
            LastName: user.lastName,
            Email: user.email,
          } as IFormJBPHPContactChangeRequest,

          partnerId: partnerId as string,
          leadId: -1,
          currentRole: '',
          isRequestAccess: true,

          onApply: applyRequestAccessHandler,
          onCancel: () => {
            setShowRequestAccessDialog(false)
          },
        }}
        onClose={() => setShowRequestAccessDialog(false)}
      />
    </>
  )
}
